import { render, staticRenderFns } from "./HomeOptionCard.vue?vue&type=template&id=5b622358"
import script from "./HomeOptionCard.vue?vue&type=script&lang=js"
export * from "./HomeOptionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports